"use client";
import { Audio } from "../../media/audio.js";
import { MinimalAudioSkin } from "./minimal-skin.js";
import { AudioPlayer, usePlayer } from "./player.js";
import { AudioSkin } from "./skin.js";
import { audioFeatures } from "@videojs/core/dom";
//#region src/presets/audio/index.ts
/** Audio-only player preset with playback and volume controls. */
//#endregion
export { Audio, AudioPlayer, AudioSkin, MinimalAudioSkin, audioFeatures, usePlayer };

//# sourceMappingURL=index.js.map